import { usePortalUri } from '@Shared/composables/usePortalUri';
import { axios } from '@Shared/plugins/axios';
import { trackAppInsightsEvent } from '@Shared/utils/util';
import { defineStore } from 'pinia';

type RequireAuthenticationResponse = {
  requiresAuthentication: boolean;
  redirectTo?: string;
};

export const useSocialStore = defineStore('social', () => {
  const trackEvent = async (action: string, props: Record<string, string | undefined>) => {
    trackAppInsightsEvent(action, props, 'SocialCX -', 'Social');
  };

  const requiresAuthentication = async () => {
    const uri = usePortalUri();
    const response = await axios.post(
      `${uri}/api/social/auth`,
      {
        redirectUrl: location.href,
      },
      {
        headers: { 'Content-Type': 'application/json' },
      }
    );

    return response.data as RequireAuthenticationResponse;
  };

  const refreshLocationDataForUser = async () => {
    const uri = usePortalUri();
    await axios.get(`${uri}/api/social/refresh`);
    return;
  };

  const logout = async () => {
    trackEvent('Logout', {});
    try {
      const uri = usePortalUri();
      await axios.get(`${uri}/api/social/logout`);
    } catch (_) {
    } finally {
      location.reload();
    }
    return;
  };

  return { requiresAuthentication, refreshLocationDataForUser, logout, trackEvent };
});
